import type { ZudokuConfig } from "zudoku";

export const search: ZudokuConfig["search"] = {
	type: "pagefind",
	// Optional: Maximum number of sub results per page
	maxSubResults: 3,
	// Optional: Configure search result ranking (defaults shown below)
	ranking: {
		termFrequency: 0.8,
		pageLength: 0.6,
		termSimilarity: 1.2,
		termSaturation: 1.2,
	},
};
